import apiClient from "config/api";

const getCustomers = async () => {
  return apiClient.get("/admin/landlords");
};

const cancelCustomerSubscription = async (landlordId, body) => {
  return apiClient.post(`/admin/landlords/cancel-subscription/${landlordId}`, body);
};

export { getCustomers, cancelCustomerSubscription };
